/** The getLayers feature fields an ESRI feature or utility request is matched on. */
export interface LayerFamily {
  id: string | number | null | undefined;
  /** Legacy `agencyId`s of the geometry owners; a merged record's children carry the ESRI ids and older requests. */
  memberAgencyIds?: string[];
}

/** Every id a layer answers to: its own feature id plus its geometry owners' legacy ids, as strings. */
export function layerFamilyIds(layer: LayerFamily): Set<string> {
  return new Set([layer.id, ...(layer.memberAgencyIds ?? [])].filter((id) => id != null && id !== '').map(String));
}

/** Whether any family id of the layer is among the `civilgrid_id`s found in the project area. */
export function layerMatchesFeature(layer: LayerFamily, features: (string | number)[]): boolean {
  const familyIds = layerFamilyIds(layer);
  return features.some((feature) => familyIds.has(String(feature)));
}

/** Whether a utility request was filed under one of the layer's family ids. */
export function requestMatchesLayer(request: { utilityAgencyId: string | number }, layer: LayerFamily): boolean {
  return layerFamilyIds(layer).has(String(request.utilityAgencyId));
}
